export const getAuthErrorMessage = (error) => {
  if (!error) return "An unexpected error occurred. Please try again.";

  const code = error.code || "";
  
  switch (code) {
    case "auth/email-already-in-use":
      return "This email is already registered. Please sign in or use another email.";
    case "auth/invalid-email":
      return "Please enter a valid email address.";
    case "auth/weak-password":
      return "Password is too weak. Please use at least 6 characters.";
    case "auth/user-not-found":
      return "No account found with this email. Please check or sign up.";
    case "auth/wrong-password":
      return "Incorrect password. Please try again.";
    case "auth/invalid-credential":
    case "auth/invalid-login-credentials":
      return "Invalid email or password. Please verify your credentials.";
    case "auth/too-many-requests":
      return "Access to this account has been temporarily disabled due to many failed login attempts. Please try again later.";
    case "auth/network-request-failed":
      return "Network connection issue. Please check your internet connection.";
    case "auth/user-disabled":
      return "This account has been disabled. Please contact support.";
    case "auth/requires-recent-login":
      return "Please log in again before retrying this action.";
    case "auth/unauthorized-domain":
      return "This domain is not authorized in Firebase. Please add your domain (e.g. vercel.app) in Firebase Console > Authentication > Settings > Authorized Domains.";
    case "auth/popup-blocked":
      return "The sign-in popup was blocked by your browser. Please allow popups for this site and try again.";
    case "auth/operation-not-allowed":
      return "Google sign-in is not enabled in Firebase Console. Please enable Google under Authentication > Sign-in method.";
    case "auth/cancelled-popup-request":
      return "Sign-in request was cancelled. Please try again.";
    case "auth/account-exists-with-different-credential":
      return "An account already exists with this email using a different sign-in method. Please sign in with your password.";
    default:
      return error.message ? error.message.replace(/^Firebase:\s*/, "") : "Something went wrong. Please try again.";
  }
};
